import type { Room } from '../db/schema';

/**
 * Two rooms with the same icon are two identical glyphs down a 72px rail,
 * and the rail is icons only. So when an icon repeats, each room using it
 * gets a number — first on the home screen is 1, the next is 2, counting only
 * the rooms sharing that icon and ignoring everything between them.
 *
 * A room whose icon nobody else uses gets nothing. Numbering every room would
 * be numbering for its own sake.
 */
export function iconOrdinals(rooms: readonly Room[]): Map<string, number> {
  const totals = new Map<string, number>();
  for (const room of rooms) totals.set(room.icon, (totals.get(room.icon) ?? 0) + 1);

  const ordinals = new Map<string, number>();
  const seen = new Map<string, number>();

  for (const room of rooms) {
    if ((totals.get(room.icon) ?? 0) < 2) continue;

    const nth = (seen.get(room.icon) ?? 0) + 1;
    seen.set(room.icon, nth);
    ordinals.set(room.id, nth);
  }

  return ordinals;
}
